<tidy-loading-bar class="js-tidy-loading desktop" />

<div class="container-top-nav">
  <div class="first-item" [ngClass]="{'full-logo-container': showFullLogo}">
    @if (!canGoBack && !showCloseItem() && !noBow && !showFullLogo) {
      <img
        decoding="async"
        class="bowtie"
        [src]="logo"
        />
    }
    @if (!canGoBack && !showCloseItem() && showFullLogo) {
      <img
        decoding="async"
        class="full-logo"
        [src]="fullLogo"
        />
    }
    @if (canGoBack) {
      <tidy-icon class="back-button desktop" [size]="27" (click)="goBack()" name="arrow-back-black" />
    }
    @if (canGoBack) {
      <tidy-icon class="back-button mobile" [size]="27" (click)="goBack()" name="arrow-back-white" />
    }

    @if (showCloseItem() && !canGoBack) {
      <tidy-icon class="close-icon desktop" (click)="executeAction(closeItemAction)" [size]="25" [name]="closeIconDesktop" [src]="closeIconSrc" />
    }
    @if (showCloseItem() && !canGoBack) {
      <tidy-icon class="close-icon mobile" (click)="executeAction(closeItemAction)" [size]="25" [name]="closeIconMobile" [src]="closeIconSrc" />
    }
  </div>
  @if (title && !subtitle) {
    <tidy-text
      class="title-text"
      [ngClass]="{'white': !windowService.isDesktopRes}"
      [title]="title" />
  }
  @if (title && subtitle) {
    <div class="title-block has-subtitle" [class.inline-subtitle]="inlineSubtitle">
      <tidy-text
        class="title-text"
        [ngClass]="{'white': !windowService.isDesktopRes}"
        [title]="title" />
      <div class="subtitle-row">
        @if (subtitleIcon) {
          <img [src]="subtitleIcon" class="subtitle-icon" alt="" />
        }
        <tidy-text
          class="subtitle-text"
          [ngClass]="{'white': !windowService.isDesktopRes}"
          [helper]="subtitle" />
      </div>
    </div>
  }

  @if (!title && countdownTarget) {
    <div>
      <tidy-text [title]="'Time Left: '" [ngClass]="{'white': !windowService.isDesktopRes}" />
      <countdown [isTopNav]="true" [target]="countdownTarget" />
    </div>
  }

  <div class="last-item" [ngClass]="{'has-second-link': showSecondLinkIcon}">
    @if (showLoadingSpinner) {
      <ion-spinner name="lines" class="header-loading-spinner mobile" style="margin-right: 15px" />
    }
    @if (showDropdownMenu && dropdownMenu && dropdownMenu.length > 0) {
      <tidy-drop-down-menu class="drop-down-menu">
        @for (item of dropdownMenu; track item) {
          <tidy-drop-down-menu-item
            (click)="dropDownMenuClicked(item.action)">
            {{item.label}}
          </tidy-drop-down-menu-item>
        }
      </tidy-drop-down-menu>
    }
    @if (secondLinkIcon && showSecondLinkIcon) {
      <span class="link-icon">
        <tidy-icon class="link-icon-element mobile" (click)="executeAction(secondLinkAction)" [size]="22" [name]="secondLinkIcon" [src]="'assets/svg/' + secondLinkIcon + '-white.svg'" />
        <tidy-icon class="link-icon-element desktop" (click)="executeAction(secondLinkAction)" [size]="22" [name]="secondLinkIcon" [src]="'assets/svg/' + secondLinkIcon + '.svg'" />
      </span>
    }
    @if (linkIcon && showLinkIcon) {
      <span class="link-icon">
        @if (linkIcon !== 'edit' && linkIcon !== 'notification') {
          <tidy-icon class="link-icon-element mobile" (click)="executeAction(linkAction)" [size]="linkIconSize" [name]="linkIcon + '-white'" [src]="linkIconSrc" [disabled]="disabledLinkAction" />
          <tidy-icon class="link-icon-element desktop" (click)="executeAction(linkAction)" [size]="linkIconSize" [name]="linkIcon + '-black'" [disabled]="disabledLinkAction" />
        }
        @if (linkIcon === 'notification') {
          <div
            (click)="navigateToNotificationCenter()"
            class="header-icon hover-effect"
            [matTooltip]="('Notifications' | translate)"
            [matTooltipPosition]="'below'"
            matTooltipClass="menu-item-tooltip below">
            <div style="position: relative; width: 25px;">
              <img style="height: 25px" [src]="'assets/img/notification-white.svg'"/>
              @if (notificationCount > 0 && notificationCount < 10) {
                <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                  {{notificationCount}}
                </div>
              }
              @if (notificationCount >= 10) {
                <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 8px; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                  9+
                </div>
              }
            </div>
          </div>
        }
        @if (linkIcon === 'edit') {
          <button
            expand="block"
            class="mat-raised-button"
            mat-button
            tappable
            (click)="executeAction(linkAction)"
            [disabled]="disabledLinkAction"
            type="submit" block
            >
            <tidy-text [smallBody]="'Edit'" class="white" />
          </button>
        }
        @if (linkIcon === 'star') {
          <span class="bubble">
            5
          </span>
        }
      </span>
    }
  </div>
</div>

<div class="tidy-top-nav-content">
  <ng-content />
</div>

<tidy-loading-bar class="js-tidy-loading mobile" />